import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame to ensure DOM is ready
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // Smooth scroll animation
      });
    };

    // Small delay to ensure DOM is ready, then smooth scroll
    const timeoutId = setTimeout(scrollToTop, 100);
    
    // Fallback with requestAnimationFrame
    requestAnimationFrame(() => {
      scrollToTop();
    });

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

